/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    var isFunction = angular.isFunction,
        isObject = angular.isObject;

    export class InsuranceDirectiveController {
        public static $inject: string[] = [
            '$scope',
            '$window',
            '$mdDialog',
            '$mdMedia',
            '$filter',
            '$dealerwareInternationalizationData'
        ];

        public insuranceAttributes: any;
        public insuranceOrigin: any;
        public insuranceImage: any;
        public imageAsThumbnail: boolean;
        public onSave: any;
        public showButtons: boolean;
        public readOnly: boolean;
        public zoomOptions: any;
        public editingInsurance: boolean;
        public labels: {};

        constructor(public $scope: any,
                    public $window: any,
                    public $mdDialog: any,
                    public $mdMedia: any,
                    public $filter: any,
                    public $dealerwareInternationalizationData: any) {
            var _self = this;
            var reset = false;
            this.getLabels('vehicles');

            this.$scope.$watchGroup([
                () => { return this.insuranceAttributes },
                () => { return this.insuranceImage }
            ], (newValues: any) => {
                var insuranceAttributes = newValues[0],
                    insuranceImage = newValues[1];

                if(insuranceAttributes && !reset){
                    this.insuranceOrigin = angular.copy(insuranceAttributes[0]);
                    reset = true;
                }

                if (insuranceAttributes && insuranceImage) {
                    insuranceAttributes[0].image = insuranceImage.data.image;
                }
            });

            this.zoomOptions = {
                style: 'box',
                zoomLevel: 3,
                boxW: 550,
                boxH: 550,
                cursor: 'pointer',
                immersiveMode: 1280
            };
        }

        public getLabels(module: string) : void {
            var _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    return {}
                }
            );
        }

        public toggleInsuranceEditor() : void {
            this.editingInsurance = !this.editingInsurance;
        }

        public cancel() : void {
            this.insuranceAttributes[0].expires_on = this.insuranceOrigin.expires_on;
            this.toggleInsuranceEditor();
        }

        public zoomInsuranceImage() : void {
            this.$mdDialog.show({
                title: 'Insurance Image',
                templateUrl: '/components/insurance/insurance_image_dialog.html',
                clickOutsideToClose: true,
                fullscreen: this.$mdMedia('xs') || this.$mdMedia('sm'),
                locals: {
                    imageUrl: this.insuranceAttributes[0].image.url,
                    zoomOptions: {
                        style: 'inner',
                        zoomLevel: 3,
                        cursor: 'none',
                        immersiveMode: 0
                    }
                },
                controller: function($scope: any, $mdDialog: any, imageUrl: string, zoomOptions: any) {
                    $scope.imageUrl = imageUrl;
                    $scope.zoomOptions = zoomOptions;
                    $scope.close = function() { $mdDialog.cancel(); }
                }
            });
        }

        public openImageInTab() : void {
            this.$window.open(this.insuranceAttributes[0].image.url);
        }

        public updateInsuranceAttributes() : void {
            if (this.insuranceAttributes && this.insuranceAttributes.length) {
                this.insuranceAttributes = this.insuranceAttributes.splice(0,1);

                this.insuranceAttributes[0].is_silvercar = false;
                this.insuranceAttributes[0].is_personal = true;
                this.insuranceAttributes[0].is_corporate = false;
                this.insuranceAttributes[0].insurance_option_id = undefined;
            }
        }

        public handleSave(deleteInsuranceImage: boolean) : void {
            var _self = this;

            if (this.onSave && isFunction(this.onSave)) {
                this.onSave({
                    record: this.insuranceAttributes,
                    deleteInsuranceImage: deleteInsuranceImage
                }).then(
                    function() { _self.$scope.insuranceForm.$setPristine(); }
                );
            }
        }
    }

    getDealerwareWebComponentsModule().controller('InsuranceDirectiveController', InsuranceDirectiveController);

    export class InsuranceDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'InsuranceDirectiveController';
        public controllerAs     : string    =   'insuranceController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            insuranceAttributes: '=',
            insuranceImage: '=',
            imageAsThumbnail: '=',
            onSave: '&',
            showButtons: '=',
            readOnly: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/insurance/insurance_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   any,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareInsurance",() => new InsuranceDirective());
 }